const Newsletter = () => {
  return (
    <section id="newsletter" className="overflow-hidden bg-[var(--st-color-navy-deep)] px-4 py-16 text-white sm:px-6 sm:py-20 lg:px-8 lg:py-24">
      <div className="mx-auto w-full max-w-7xl">
        <div className="mx-auto flex max-w-[1304px] flex-col items-center text-center">
          <h2 className="st-font-display max-w-[13ch] text-[clamp(42px,4vw,78px)] leading-[0.95] tracking-[-0.04em] text-white sm:max-w-none">
            Jangan Ketinggalan
            <br />
            <span className="italic">Info Beasiswa</span> Terbaru!
          </h2>

          <p className="mt-8 max-w-[742px] text-[clamp(18px,1.8vw,28px)] leading-[1.45] text-[rgba(255,255,255,0.58)] sm:mt-10">
            Daftarkan emailmu dan dapatkan update artikel, deadline beasiswa, dan tips IELTS setiap minggu
          </p>

          <form className="mt-10 flex w-full max-w-[956px] flex-col items-stretch gap-4 sm:mt-12 sm:flex-row sm:items-stretch sm:gap-4" onSubmit={(event) => event.preventDefault()}>
            <label className="w-full sm:flex-1">
              <span className="sr-only">Email address</span>
              <input
                type="email"
                name="email"
                placeholder="email@kamu.com"
                className="h-[72px] w-full rounded-[18px] border border-[rgba(255,255,255,0.14)] bg-[rgba(255,255,255,0.16)] px-6 text-[16px] text-white placeholder:text-[rgba(255,255,255,0.42)] shadow-[inset_0_1px_0_rgba(255,255,255,0.08)] outline-none transition-colors duration-200 focus:border-[rgba(255,255,255,0.26)] focus:bg-[rgba(255,255,255,0.2)] sm:h-[88px] sm:px-8 sm:text-[18px] lg:h-[104px] lg:px-10 lg:text-[24px]"
              />
            </label>

            <button
              type="submit"
              className="h-[72px] w-full rounded-[18px] bg-[var(--st-color-yellow)] px-8 text-[24px] font-semibold text-[var(--st-color-navy)] shadow-[0_12px_24px_rgba(0,0,0,0.12)] transition-all duration-300 ease-out hover:bg-[#cca83d] hover:shadow-[0_16px_30px_rgba(0,0,0,0.18)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--st-color-navy-deep)] sm:h-[88px] sm:min-w-[200px] sm:w-auto sm:px-10 sm:text-[24px] lg:h-[104px] lg:min-w-[255px] lg:px-10 lg:text-[28px]"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;